import React, { Component } from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const Reports = () => {
    return (
        <div id="reports-report">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Reports</h2>
                        <ul>
                            <li>Go to Menu {`>`} Report</li>
                            <li>Select the Report you want to see</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default Reports;